import React, { Component } from 'react';
import ReactDom from 'react-dom';
import SceDialogBox from "../../../../Common/CommonComponents/sceDialogBox";
import SceTimeoutDialog from "../../../../Login/LoginRegisterButton/Presentational/sceTimeoutDialog";
class TimeOut extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            displayDialog: false
        };
        this.modalRoot = document.createElement('div');
        this.modalRoot.id = 'mfa-modal-timeout';
    }

    componentDidMount() {
        document.body.appendChild(this.modalRoot);
        this.setState({ displayDialog: true });
    }

    componentWillUnmount() {
        document.body.removeChild(this.modalRoot);
    }

    onTimeoutDialogOk = () => {
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.HOME_LOGIN);
    }

    render() {
        const { displayDialog } = this.state;
        return ReactDom.createPortal(
            <SceDialogBox Title='Timeout Box' showCloseButton='true' width='500' isUserSessionExpired tncType displayDialog={displayDialog}>
                <SceTimeoutDialog
                    onTimeoutDialogOk={this.onTimeoutDialogOk}
                    timedOut
                />
            </SceDialogBox>, this.modalRoot
        );
    }

}

export default TimeOut;
